<template>
  <div class="box">
    <!-- 顶部图片 -->
    <div class="topBg"></div>
    <!-- tabs切换 -->
    <van-tabs sticky @change="CateIdClick">
      <van-tab v-for="item in allListType" :key="item.id" :name="item.id" :title="item.name">
      </van-tab>
    </van-tabs>
    <!-- 列表 -->
    <!-- 没有更多了 -->
    <van-list :loading="loading" :finished="finished" finished-text="没有更多了" offset="50" :immediate-check="false"
      @load="onLoad">
      <div class="lists">
        <!--  @click="gotoUrl('/guanghe/index/' + item.LeaseId)"> @click="gotoUrl('/guanghe/details/' + item.LeaseId)" -->
        <div v-if="typeTab == 1" style="width: 100%; display: flex;align-items: flex-start;flex-wrap: wrap;">
          <div class="list" v-for="item in list" :key="item.id"
            @click="gotoUrl('/Changan-zhsq/tenement/lesseeDetails/' + item.id+'/' + booleanData)">
            <div style="display: flex; border-bottom: 1px solid #f4f4f4;flex-direction: column;width: 100%;">
              <div class="listImg">
                <img v-if="item.Imgs != null && item.Imgs != ''" :src="item.Imgs.split(',')[0]"
                  style="width: 100%; height: 100%; border-radius: 4px" />
                <img v-else src="https://new-zhsq.oss-cn-beijing.aliyuncs.com/goodsImg/16b3.png"
                  style="width: 100%; height: 100%; border-radius: 4px" />
              </div>
              <div class="listTitle">
                <!-- <span style="height: 44%">{{ item.RoomSource }}</span> -->
                <div style="height: 26%" class="userinfo_title">{{ item.title }}</div>
                <div class="userinfo">
                  <!-- <div class="userinfo_TouchMan">
                  <div class="image"><img src="../../../../public/oldManBill/people.png" alt=""></div>
                  <div>{{ item.TouchMan }}</div>
                </div> -->
                  <div class="userinfo_TouchTel" style="width: 100%;" @click.stop="callPhone(item.oriPhone)">
                    <div class="image"><img src="../../../../public/oldManBill/phone.png" alt=""></div>
                    <div>{{ item.phone }}</div>
                  </div>
                </div>
                <!-- <div class="listLabel">
                  <div class="yamoney" style="display: flex; align-items: center; width: 100%;">
                    <span>内容: </span>
                    <div v-html="item.content" class="htmlBox" style="margin-left: 5px; width: 75%; "> </div>
                  </div>
                </div> -->
                <div class="evaluating_btnBox" v-if="type==0">
                  <van-button type="info" size="mini" style="color: #fff;"
                    v-if="userInfo.isGrid == 1 && item.status == 0" @click.stop="auditFun(1, item)">审核</van-button>
                  <van-button type="info" v-if="item.openId == openId" size="mini" style="color: #fff;"
                    @click.stop="goEidt(1, item)">编辑</van-button>
                  <van-button type="danger" v-if="item.openId == openId" size="mini"
                    @click.stop="deleteFun(1, item)">删除</van-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="typeTab == 2" style="width: 100%; display: flex;align-items: flex-start;flex-wrap: wrap;">
          <div class="list" v-for="item in list" :key="item.id"
            @click="gotoUrl('/Changan-zhsq/tenement/details/' + item.LeaseId)">
            <div style="display: flex; border-bottom: 1px solid #f4f4f4;flex-direction: column;width: 100%;">
              <div class="listImg">
                <img v-if="item.Imgs != null && item.Imgs != ''" :src="item.Imgs.split(',')[0]"
                  style="width: 100%; height: 100%; border-radius: 4px" />
                <img v-else src="https://new-zhsq.oss-cn-beijing.aliyuncs.com/goodsImg/16b3.png"
                  style="width: 100%; height: 100%; border-radius: 4px" />
              </div>
              <div class="listTitle">
                <!-- <span style="height: 44%">{{ item.RoomSource }}</span> -->
                <div style="height: 26%" class="userinfo_title">{{ item.title }}</div>
                <div class="userinfo">
                  <div class="userinfo_TouchMan">
                    <div class="image"><img src="../../../../public/oldManBill/people.png" alt=""></div>
                    <div>{{ item.TouchMan }}</div>
                  </div>
                  <div class="userinfo_TouchTel" @click.stop="callPhone(item.oriTouchTel)">
                    <div class="image"><img src="../../../../public/oldManBill/phone.png" alt=""></div>
                    <div>{{ item.TouchTel }}</div>
                  </div>
                </div>
                <div class="userinfo_Address">
                  <div class="image">
                    <!-- <img src="../../../public/oldManBill/address.png" alt=""> -->
                    <img src="../../../../public/oldManBill/address.png" alt="">
                  </div>
                  <div class="userinfo_address"> {{ item.Address }}</div>
                </div>
                <div>

                </div>
                <div class="listLabel">
                  <!-- <div
                style="
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 1;
                "
              >
               {{ item.Address }}
              </div> -->
                  <div class="money">
                    {{ Number(item.Price) }}
                    <i style="color: #fc4839; font-size: 13px; font-style: normal">元/月</i>
                  </div>
                  <div class="yamoney">
                    押金方式: {{ item.Deposit }}
                  </div>
                  <!-- <div class="evaluating_btnBox" v-if="item.OpenID == openId"> -->

                </div>
                <div class="evaluating_btnBox" style="margin-top: 5px;">
                  <van-button type="info" size="mini" style="color: #fff;"
                    v-if="userInfo.isGrid == 1 && item.Status == 0" @click.stop="auditFun(2, item)">审核</van-button>
                  <van-button type="info" size="mini" style="color: #fff;" v-if="item.OpenID == openId"
                    @click.stop="goEidt(2, item)">编辑</van-button>
                  <van-button type="danger" size="mini" v-if="item.OpenID == openId"
                    @click.stop="deleteFun(2, item)">删除</van-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-list>

    <!-- 发布按钮小按钮 -->
    <div class="backTop" v-if="typeTab == 2&&type==0" @click="gotoUrl('/Changan-zhsq/tenement/addXianzhi/' + null+'/'+openId)">

      <!-- v-if="isWorkMan == 1" -->

      <img class="top_iamge" src="https://new-zhsq.oss-cn-beijing.aliyuncs.com/goodsImg/eae3.png" alt="" />
    </div>
    <div class="backTop" v-if="typeTab == 1&&type==0" @click="gotoUrl('/Changan-zhsq/tenement/addlessee/' + null+'/'+openId)">
      <img class="top_iamge" src="https://new-zhsq.oss-cn-beijing.aliyuncs.com/goodsImg/eae3.png" alt="" />
    </div>
    <van-dialog title="审核" v-model="auditShow" show-cancel-button show-confirm-button overlay @close="onClose"
      @confirm="auditSubmit">
      <van-radio-group v-model="radioValue" @change="radioChange" class="radio_group">
        <van-radio name="1">通过</van-radio>
        <van-radio :name="curType == 1 ? 2 : 3" style="margin-left: 15px;">拒绝</van-radio>
      </van-radio-group>
    </van-dialog>
  </div>
</template>
<script>
import { WxGetLeasePage, listLessee, delLessee, DeleteLease, addLessee, WxSaveMyLease } from '@/api/Changan-zhsq/evaluating'
import {
  WxIsMember
} from '@/api/Changan-zhsq/yeguang'
import Vue from 'vue'
import { Toast } from 'vant'
import { Dialog } from 'vant'
Vue.use(Toast)
Vue.use(Dialog)
export default {
  data() {
    return {
      booleanData:false,
      loading: false, //加载
      finished: false, //数据完全加载结束为 true
      // 分页需要的参数
      listfrom: {
        // typeId:0,
        page: 1,
        limit: 10,
        Status: 1
        // pAKind: 1,
      },
      infoId: this.$route.params.id,
      list: [
        /* {
          Logo: 'https://dximg.dexian.ren/111.png',
          Name: '九鼎中和湾三室精装 周边配套完善观河景 环境舒适 地铁口',
          WorkTime: '2室·93.13m²·九鼎中和湾·古城路',
          Address: '1700',
        }, */
      ],
      // 所有房屋类型
      allListType: [
        {
          id: 1,
          name: '我要租'
        },
        {
          id: 2,
          name: '我有房'
        }
      ],
      typeTab: 1,
      openId: '',
      userInfo: {},
      auditShow: false,
      curType: 0,
      curItem: {},
      radioValue: 0,
      type:0,//0我的租房 1首页租房
    }
  },
  mounted() {
    this.openId = this.$route.query.openid
    this.type = this.$route.query.type
    this.MemberInfo()
  },
  methods: {
    radioChange() {
      console.log(this.radioValue)
    },
    auditFun(type, item) {
      console.log(type)
      this.auditShow = true
      this.curType = type
      this.curItem = item
    },
    onClose() {
      this.auditShow = false
    },
    auditSubmit() {
      if (!this.radioValue || this.radioValue == 0) {
        Dialog.alert({
          title: '提示',
          message: '请选择通过或者拒绝!',
        })
        return
      }
      this.listfrom.page = 1
      this.list = []
      if (this.curType == 1) {
        this.curItem.status = this.radioValue * 1
        addLessee(this.curItem).then((res) => {
          if (res.data.code == 0) {
            console.log(this.curItem, 'dzx1234567890')
            console.log(res.data)
            Dialog.alert({
              title: '提示',
              message: '提交成功!',
            }).then(() => {
              this.getLesseePsge()
            })
          } else {
            Dialog.alert({
              title: '提示',
              message: '提交失败!' + res.data.msg,
            }).then(() => {

            })
          }
        })
      } else {
        this.curItem.Status = this.radioValue * 1
        WxSaveMyLease(this.curItem).then((res) => {
          if (res.data.code == 0) {
            Dialog.alert({
              title: '提示',
              message: '提交成功!',
            }).then(() => {
              this.getCommNoticeList();
            })
          } else {
            Dialog.alert({
              title: '提示',
              message: '提交失败!' + res.data.msg,
            }).then(() => {
            })
          }
        })

      }
    },
    MemberInfo() {
      WxIsMember({ OpenID: this.openId }).then((res) => {
        if (res.data.code == 0) {
          if (res.data.msg == '接口已关闭！') {
            this.booleanData=false;
          }else{
            this.booleanData=true;
            const data = res.data.data
            this.userInfo = data
            this.getLesseePsge()
            console.log(data)
          }
        } else {
          this.booleanData=false;
          this.verifyshow = 0;
          Toast.fail(res.data.msg);
        }
      });
    },
    // 切换分类
    CateIdClick(val) {
      console.log(val, "123");
      this.finished = false;
      this.listfrom.page = 1
      this.list = []
      console.log(val == 1)
      this.typeTab = val
      if (val == 1) {
        this.getLesseePsge()
      } else {
        this.getCommNoticeList();
      }
    },
    //跳转到公共页面
    gotoUrl(path) {
      if (window.__wxjs_environment === 'miniprogram') {
        window.wx.miniProgram.navigateTo({
          url: '../public/goto?path=' + path,
        })
      } else {
        this.$router.push(path)
      }
    },
    // 上拉加载需要的函数
    onLoad() {
      console.log("asdsad");
      this.listfrom.page = this.listfrom.page + 1;
      this.loading = true;
      if (this.typeTab == 1) {
        this.getLesseePsge()
      } else {
        this.getCommNoticeList();
      }
    },
     callPhone(phone) {
      window.location.href = "tel:" + phone;
    },
    maskPhoneNumberWithRegex(phoneNumber) {
      if (!phoneNumber) {
        return
      }
      if (typeof phoneNumber !== 'string' || !/^\d{11}$/.test(phoneNumber)) {
        // throw new Error('Invalid phone number');
        return phoneNumber
      }
      return phoneNumber.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    },
    // 获取页面
    getCommNoticeList() {
      // if(this.type=='0'){
      //   this.listfrom.OpenID = this.openId
      // }else{
      //   this.listfrom.OpenID = this.openId
      // }
      // this.listfrom.Status = this.userInfo.isGrid == 1 ? null : 1
      let params={};
      if(this.type=='0'){
        params={
          flag:0,
          OpenID: this.openId,
          page: this.listfrom.page,
          limit: 10,
          Status: this.userInfo.isGrid == 1 ? null : 1
        }
      }else{
        params={
          OpenID: this.openId,
          flag:1,
          page: this.listfrom.page,
          limit: 10,
          Status: this.userInfo.isGrid == 1 ? null : 1
        }
      }
      WxGetLeasePage(params).then((res) => {
        this.loading = false;
        console.log(res, 1111);
        if (res.data.code == 0) {
          let rows = res.data.data; //请求返回当页的列表
          // 加载状态结束
          rows.forEach(e => {
            e.oriTouchTel = e.TouchTel
            e.TouchTel = this.maskPhoneNumberWithRegex(e.TouchTel)
          });
          if (rows == null || rows.length === 0) {
            // 加载结束
            console.log("结束");
            this.finished = true;
            return;
          }
          // 将新数据与老数据进行合并
          this.list = this.list.concat(rows);
          //如果列表数据条数>=总条数，不再触发滚动加载
          if (this.list.length >= res.data.count) {
            this.finished = true;
          }
        } else {
          this.finished = true;
        }
      });
    },
    getLesseePsge() {
      let params={};
      if(this.type=='0'){
        params={
          flag:0,
          openId: this.openId,
          page: this.listfrom.page,
          limit: 10,
          Status: this.userInfo.isGrid == 1 ? null : 1
        }
      }else{
        params={
          openId: this.openId,
          flag:1,
          page: this.listfrom.page,
          limit: 10,
          Status: this.userInfo.isGrid == 1 ? null : 1
        }
      }
      listLessee(params).then((res) => {
        this.loading = false;
        console.log(res, 1111);
        if (res.data.code == 0) {
          let rows = res.data.data; //请求返回当页的列表
          // 加载状态结束
          rows.forEach(e => {
            e.oriPhone = e.phone
            e.phone = this.maskPhoneNumberWithRegex(e.phone)
          });
          if (rows == null || rows.length === 0) {
            // 加载结束
            console.log("结束");
            this.finished = true;
            return;
          }
          // 将新数据与老数据进行合并
          this.list = this.list.concat(rows);
          //如果列表数据条数>=总条数，不再触发滚动加载
          if (this.list.length >= res.data.count) {
            this.finished = true;
          }
        } else {
          this.finished = true;
        }
      });
    },
    deleteFun(type, item) {
      // delLessee, DeleteLease
      Dialog.confirm({
        title: '提示',
        message: '确认删除吗？',
      })
        .then(() => {
          this.listfrom.page = 1
          this.list = []
          if (type == 1) {
            let params={
              id:item.id,
              openId: this.$route.query.openid
            }
            delLessee(params).then((res) => {
              Dialog.alert({
                title: '提示',
                message: '删除成功',
              }).then(() => {
                this.getLesseePsge()
              });
            })
          } else {
            let params={
              LeaseId: item.LeaseId,
              OpenID:  this.$route.query.openid
            }
            DeleteLease(params).then((res) => {
              Dialog.alert({
                title: '提示',
                message: '删除成功',
              }).then(() => {
                this.getCommNoticeList();
              });
            })
          }
          // on confirm
        })
        .catch(() => {
          // on cancel
        });
      if (type) {

      }
    },
    goEidt(type, item) {
      if (type == 1) {
        this.gotoUrl('/Changan-zhsq/tenement/addlessee/' + item.id+'/'+this.openId)
      } else {
        this.gotoUrl('/Changan-zhsq/tenement/addXianzhi/' + item.LeaseId+'/'+this.openId)
      }
    }
  },
}
</script>
<style scoped>
.box {
  background: #fff;
  /* height: 100%; */
  min-height: 100vh;
}

/* 背景 */
.topBg {
  position: relative;
  margin: auto;
  height: 90px;
  width: 92%;
  background: url('https://dximg.dexian.ren/banner.png') no-repeat center;
  background-size: 100% 100%;
  margin-bottom: 10px;
}

/* 列表 */
.lists {
  display: flex;
  justify-content: left;
  align-items: center;
  flex-wrap: wrap;
  padding: 10px;
}

.lists .list {
  width: 48%;
}
.lists .list:nth-child(2n){
  margin-left: 4%;
}
.lists .listImg {
  width: 100%;
  height:auto;
  text-align: center;
  margin: 10px 3% 0;
}

.listTitle {
  flex: 1;
  margin: 12px 0;
}

.listTitle span:nth-child(1) {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #231815;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.listTitle .van-button__text {
  color: #fff !important;
  font-weight: normal !important;
}

.listLabel div:nth-child(1) {
  /* margin-bottom: 1px; */
}

.listLabel {
  display: flex;
  margin-top: 6px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
  align-items: center;
  /* justify-content: space-between; */
}

.money {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #fc4839;
  width: 50%;
}

.yamoney {
  color: #999;

}

/* 购物车 */
.shopping {
  position: fixed;
  right: 15px;
  bottom: 25px;
  width: 65px;
  height: 65px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 4px #f5eeee;
}

.goodsLists {
  width: 95%;
  margin: 10px auto 10px;
  background: #fff;
  height: 57vh;
  border-radius: 10px;
  overflow-y: scroll;
}

.goodsList {
  display: flex;
  justify-items: center;
  /* align-items: center; */
  background: #fff;
  border-radius: 10px;
  margin-bottom: 7px;
}

.button {
  width: 100%;
  text-align: center;
}

.flex {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0px;
}

.button button {
  position: fixed;
  bottom: 15px;
  width: 80%;
  height: 40px;
  line-height: 40px;
  background: #01a0fb;
  color: #fff;
  border: none;
  margin: 8px auto 15px;
  border-radius: 6px;
  left: 10%;
}

.goodsList .delete {
  background: #ee0c24;
  border: none;
  color: #fff;
  font-size: 14px;
  border-radius: 7px;
  padding: 5px 13px;
}

.address .van-radio {
  background: #f5f5f5;
  width: 80%;
  margin: 10px auto;
  padding: 6px 15px;
  border-radius: 6px;
}

.address .radioBox {
  display: flex;
  justify-content: space-between;
  width: 70vw;
  font-size: 14px;
}

.integralBox {
  position: absolute;
  bottom: 81px;
  font-size: 12px;
  margin-left: 10%;
}


/* 发布小按钮 */
.backTop {
  display: flex;
  position: fixed;
  bottom: 125px;
  right: 10px;
  width: 75px;
  height: 75px;
}

.userinfo {
  display: flex;
  justify-content: space-between;
  color: #999999;
  font-size: 14px;
  margin: 5px 0;
}

.userinfo_TouchMan,
.userinfo_TouchTel {
  width: 50%;
  display: flex;
  align-items: center;

}

.userinfo .image {
  width: 16px;
  height: 16px;
  margin-right: 5px;
}

.userinfo_Address .image {
  width: 16px;
  height: 16px;
  margin-right: 5px;
}

.userinfo img {
  width: 100%;
}

.userinfo_Address {
  display: flex;
  color: #999999;
  font-size: 14px;
}

.userinfo_Address img {
  width: 100%;
}

.userinfo_title {
  font-size: 20px;
}

.evaluating_btnBox {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.radio_group {
  display: flex;
  align-items: center;
  padding: 20px;
  justify-content: center;
}
</style>
<style>
.htmlBox p {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /* 限制显示四行 */
  -webkit-box-orient: vertical;
  line-height: 1.5;
  /* 根据需要调整行高 */
}
</style>
